import React, { useRef } from "react";

import { colorBands } from "src/organization/pages/project/environment/metrics/constant";
import ActivityTooltip from "src/organization/pages/project/environment/metrics/http/components/activities/Tooltip";
import RoundLegend from "src/organization/pages/project/environment/metrics/http/components/RoundLegend";
import Tooltip from "src/organization/pages/project/environment/metrics/http/components/tooltip";
import {
  Flex,
  Table,
  TableRow,
  Td
} from "src/organization/pages/project/environment/metrics/http/components/tooltip/style";
import { useHttpMetricsContext } from "src/organization/pages/project/environment/metrics/http/context";
import { CurserDataType } from "src/organization/pages/project/environment/metrics/http/types";

import { ServerCachesMetricsType } from "./types";
import { sortMetricsByCaches, serverCachesName } from "./utils";

type ServerCachesTooltipProps = {
  cursorData?: CurserDataType<ServerCachesMetricsType>;
  series: ServerCachesMetricsType[][];
  enable: boolean;
};

const ServerCachesTooltip = (props: ServerCachesTooltipProps) => {
  const tooltipRef = useRef();

  const { absoluteY, absoluteX, dataIndex, activityId } =
    props.cursorData || {};

  const activities = useHttpMetricsContext()?.activities;
  const activity = activityId
    ? activities?.find(act => act.id === activityId)
    : null;

  const indexedSeries =
    dataIndex !== undefined
      ? props.series
          .map((caches, i) => {
            const metric = caches[dataIndex];
            return { ...metric, color: colorBands[i] };
          })
          .sort(sortMetricsByCaches)
      : [];

  return (
    <Tooltip
      isVisible={props.enable}
      forwardedRef={tooltipRef}
      x={absoluteX}
      y={absoluteY}
    >
      <Table>
        <tbody>
          {indexedSeries.map(d =>
            d ? (
              <TableRow key={d.type}>
                <Td>
                  <Flex>
                    <RoundLegend color={d.color} />
                    <span className="bold">{`${d.values} %`}</span>
                  </Flex>
                </Td>
                <Td setMinWidth={false}>{serverCachesName[d.type]}</Td>
              </TableRow>
            ) : null
          )}
          {activity && (
            <TableRow isActive={true}>
              <Td colSpan={4}>
                <ActivityTooltip activity={activity} />
              </Td>
            </TableRow>
          )}
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default ServerCachesTooltip;
